import { useMemo } from 'react';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useSession } from '@packages/shared/src/hooks/useSession/useSession';
import { apiKeyManager } from '@empiriecom/mybuy-session/ApiKey';
import { LoginApi as GeneratedLoginApi } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/apis/LoginApi';
import { Configuration } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/runtime';
import FixFeatureUrlMiddleware from '@empiriecom/mybuy-session/fixFeatureUrlMiddleware/index';

const isClient = typeof window !== 'undefined';

/*
 * This is a temporary implementation until it is decided how the mybuy packages should be migrated to the nextjs Stack
 * TODO: when above is done, remove this and use the new fully migrated APIs
 */
export const useLoginApi = () => {
  const { jwtToken } = useSession();
  const config = useConfig();

  return useMemo<GeneratedLoginApi | null>(() => {
    if (isClient && jwtToken) {
      return new GeneratedLoginApi(
        new Configuration({
          fetchApi: (input, init) => fetch(input, init),
          headers: { accept: 'application/json' },
          apiKey: jwtToken,
          middleware: [
            apiKeyManager.sessionInvalidationMiddleware,
            new FixFeatureUrlMiddleware('feature-backend-customer'),
          ],
          basePath: config.apiEndpoints.customer,
        }),
      );
    }
    return null;
  }, [config, jwtToken]);
};
